// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as LocalStorage$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocalStorage.res.mjs";
import * as MatrixData$LiteracyplanetClientSxEntry from "./MatrixData.res.mjs";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";
import * as AcademyCurrentMd5Query$LiteracyplanetClientSxEntry from "./AcademyCurrentMd5Query.res.mjs";
import * as AcademyParallaxQueries$LiteracyplanetClientSxEntry from "./AcademyParallaxQueries.res.mjs";
import * as AcademyBackgroundQueries$LiteracyplanetClientSxEntry from "./AcademyBackgroundQueries.res.mjs";

var key = "academyParallaxData";

function toString(dict) {
  return Belt_Option.getExn(JSON.stringify(dict));
}

function fromString(data) {
  return Belt_Option.map(data, (function (d) {
                return JSON.parse(d);
              }));
}

var LocalStorageConfig_default = {
  returnFromActivityId: undefined
};

var LocalStorageConfig = {
  $$default: LocalStorageConfig_default,
  key: key,
  toString: toString,
  fromString: fromString
};

var ReturnFromActivity = LocalStorage$LiteracyplanetClientFlags.Make({
      key: key,
      fromString: fromString,
      toString: toString
    });

function useReturnFromActivity(returnFromActivityId) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var match = ReturnFromActivity.useLocalStorageWithNamespace(user.userId);
  var setter = match[1];
  var res = match[0];
  var setReturn = function (returnFromActivityId) {
    setter({
          returnFromActivityId: returnFromActivityId
        });
  };
  if (returnFromActivityId !== undefined) {
    return [
            returnFromActivityId,
            setReturn
          ];
  } else if (res !== undefined) {
    return [
            res.returnFromActivityId,
            setReturn
          ];
  } else {
    return [
            undefined,
            setReturn
          ];
  }
}

function AcademyParallaxData$Provider$Data(props) {
  var md5 = props.md5;
  var onPlayActivity = props.onPlayActivity;
  var match = React.useState(function () {
        
      });
  var setCategory = match[1];
  var category = match[0];
  var match$1 = React.useState(function () {
        return 0;
      });
  var setActiveCategoryWindow = match$1[1];
  var match$2 = React.useState(function () {
        return "LEVEL_0";
      });
  var setLevel = match$2[1];
  var currentLevel = match$2[0];
  var match$3 = React.useState(function () {
        return "NoLoading";
      });
  var setLoadNextWindow = match$3[1];
  var returnFromActivityId = React.useRef(props.returnFromActivityId);
  var query = AcademyParallaxQueries$LiteracyplanetClientSxEntry.use(md5, "academy", currentLevel, category, returnFromActivityId.current);
  var match$4 = MatrixData$LiteracyplanetClientSxEntry.useMenu(md5, "academy", category !== undefined ? (
          category.hasActivities ? undefined : category.id
        ) : (
          query.loading ? undefined : Belt_Array.reduce(query.data, undefined, (function (a, c) {
                    if (typeof c !== "object" || c.TAG !== "Strands") {
                      return a;
                    } else {
                      return Belt_Option.map(Belt_Array.get(c._0, 0), (function (s) {
                                    return s.parentId;
                                  }));
                    }
                  }))
        ));
  var queryMatrix = match$4[1];
  var match$5 = MatrixData$LiteracyplanetClientSxEntry.useActivities(Caml_option.some(md5), "academy", category !== undefined && category.hasActivities ? category.id : undefined);
  var queryMatrixActivities = match$5[1];
  var background = AcademyBackgroundQueries$LiteracyplanetClientSxEntry.use();
  React.useEffect((function () {
          if (query.loading) {
            
          } else {
            setLoadNextWindow(function (param) {
                  return "NoLoading";
                });
          }
        }), [query.loading]);
  var onClickLevel = function (level) {
    setCategory(function (param) {
          
        });
    setLevel(function (param) {
          return level;
        });
  };
  var onClickActivity = function (activity) {
    onPlayActivity(activity.id, activity.title);
  };
  var onClickCategory = function (category, index) {
    var setLoadWindowAndCategory = function (loadWindow) {
      setLoadNextWindow(function (param) {
            return loadWindow;
          });
      setCategory(function (param) {
            return category;
          });
    };
    var last = Belt_Array.get(query.breadcrumb, query.breadcrumb.length - 1 | 0);
    if (last !== undefined && last.id !== category.parentId) {
      if (Belt_Array.some(query.breadcrumb, (function (bc) {
                return bc.id === category.id;
              }))) {
        return setLoadNextWindow(function (param) {
                    return {
                            TAG: "NavigateToWindow",
                            _0: index + 1 | 0
                          };
                  });
      } else {
        return setLoadWindowAndCategory({
                    TAG: "ReplaceExistingWindow",
                    _0: index + 1 | 0
                  });
      }
    } else {
      return setLoadWindowAndCategory({
                  TAG: "LoadNewWindow",
                  _0: index + 1 | 0
                });
    }
  };
  React.useEffect((function () {
          var isReturningFromActivity = function (param) {
            if (category !== undefined) {
              return false;
            }
            var match = returnFromActivityId.current;
            if (match !== undefined) {
              return !query.loading;
            } else {
              return false;
            }
          };
          var updateLevelFromBreadcrumb = function (param) {
            Belt_Option.map(Belt_Option.flatMap(Belt_Array.get(query.breadcrumb, 0), (function (param) {
                        var title = param.title;
                        return Belt_Array.getBy(query.levels, (function (param) {
                                      return param[2] === title;
                                    }));
                      })), (function (param) {
                    var level = param[0];
                    setLevel(function (param) {
                          return level;
                        });
                  }));
          };
          if (isReturningFromActivity()) {
            Promise.all(Belt_Array.map(query.breadcrumb, (function (bc) {
                        if (bc.hasActivities) {
                          return queryMatrixActivities(bc.id);
                        } else {
                          return queryMatrix(bc.id);
                        }
                      })));
            updateLevelFromBreadcrumb();
          }
          var id = setTimeout((function () {
                  if (!isReturningFromActivity()) {
                    return ;
                  }
                  var len = query.breadcrumb.length;
                  Belt_Option.map(Belt_Array.get(query.breadcrumb, len - 1 | 0), (function (cat) {
                          onClickCategory(cat, len - 2 | 0);
                        }));
                  returnFromActivityId.current = undefined;
                }), 1000);
          return (function () {
                    clearTimeout(id);
                  });
        }), [
        returnFromActivityId,
        query.loading
      ]);
  var onClickBreadcrumb = function (index) {
    setLoadNextWindow(function (param) {
          return {
                  TAG: "NavigateToWindow",
                  _0: index
                };
        });
  };
  var onActiveCategoryWindowChanged = function (i) {
    setActiveCategoryWindow(function (param) {
          return i;
        });
  };
  return React.createElement(AcademyParallaxTypes$LiteracyplanetClientSxEntry.Provider.make, {
              value: {
                query: query,
                strand: Belt_Array.get(query.breadcrumb, 1),
                background: background,
                currentLevel: currentLevel,
                activeCategoryWindow: match$1[0],
                onGetMatrix: match$4[0],
                onGetMatrixActivity: match$5[0],
                onActiveCategoryWindowChanged: onActiveCategoryWindowChanged,
                onBack: props.onBack,
                onClickCategory: onClickCategory,
                onClickBreadcrumb: onClickBreadcrumb,
                onClickActivity: onClickActivity,
                onClickLevel: onClickLevel,
                loadWindow: match$3[0]
              },
              children: props.children
            });
}

var Data = {
  make: AcademyParallaxData$Provider$Data
};

function AcademyParallaxData$Provider(props) {
  var md5 = props.md5;
  var onBack = props.onBack;
  var onPlayActivity = props.onPlayActivity;
  var fetchMd5 = AcademyCurrentMd5Query$LiteracyplanetClientSxEntry.use("academy");
  var match = React.useState(function () {
        return md5;
      });
  var setMd5 = match[1];
  var md5$1 = match[0];
  var match$1 = useReturnFromActivity(props.returnFromActivityId);
  var setReturnFromActivityId = match$1[1];
  var onPlayActivity$1 = function (id, title) {
    setReturnFromActivityId(id);
    onPlayActivity(id, title);
  };
  var onBack$1 = function (param) {
    setReturnFromActivityId(undefined);
    onBack();
  };
  React.useEffect((function () {
          var updateMd5 = async function () {
            var res = await fetchMd5();
            return setMd5(function (param) {
                        if (res !== undefined) {
                          return res.academyCurrentMd5;
                        } else {
                          return md5$1;
                        }
                      });
          };
          if (Belt_Option.isSome(md5$1)) {
            setMd5(function (param) {
                  return md5$1;
                });
          } else {
            updateMd5();
          }
        }), []);
  if (Belt_Option.isSome(md5$1)) {
    return React.createElement(AcademyParallaxData$Provider$Data, {
                onPlayActivity: onPlayActivity$1,
                onBack: onBack$1,
                md5: md5$1,
                returnFromActivityId: match$1[0],
                children: props.children
              });
  } else {
    return null;
  }
}

var Provider = {
  Data: Data,
  make: AcademyParallaxData$Provider
};

export {
  LocalStorageConfig ,
  ReturnFromActivity ,
  useReturnFromActivity ,
  Provider ,
}
/* ReturnFromActivity Not a pure module */
